import httpManager from "@/app/shared/utils/httpManager";

export async function downloadTtsTemplate(data) {
  const response = await httpManager.post("/strategies/ivr-tts/download-template/", data, {
    blob: true,
  });
  return response.data;
}
